<template>
  <div class="app-container">
    <div class="mapping-table">
      <el-row class="page-buttons">
        <editor-button action="cancel" style="float:right" @click="close" />
        <editor-button
          :icon-only="false"
          action="save"
          style="float:right;margin-right:10px"
          @click="saveSelection()"
        />
      </el-row>
      <el-table
        ref="productTypeMappingList"
        v-loading="false"
        :data="items"
        border
        fit
        highlight-current-row
        style="width: 60%;margin: 0 auto"
      >
        <el-table-column :label="$t('productTypeMapping.gomFabricKindAndType')" property="gomFabricKindAndType">
          <template slot-scope="scope">
            <span>{{ scope.row['gomFabricKindAndType'] }}</span>
          </template>
        </el-table-column>
        <el-table-column label-class-name="filter-cell">
          <template slot="header" slot-scope="{}"> </template>

          <el-table-column :label="$t('productTypeMapping.webAtelierProductType')">
            <template slot-scope="{ row }">
              <el-select
                v-model="row.webAtelierProductTypeDescription"
                class="search-select"
                size="mini"
                type="select"
                clearable
                @input="handleProductTypeChange(row, $event)"
              >
                <el-option-group>
                  <el-option
                    v-for="productType in productTypees"
                    :key="productType.description"
                    :label="productType.description"
                    :value="productType.description"
                  />
                </el-option-group>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import { entityToStore } from '@/utils/store';
import { closeCurrentTag } from '@/utils/tags';

export default {
  name: 'ProductTypeMappingList',
  components: {
    EditorButton
  },
  props: {
    entity: {
      default: 'ProductTypeMapping',
      type: String
    },
    permissionCode: String
  },
  data() {
    return {
      entityStoreName: entityToStore(this.entity),
      errorMsg: '',
      defaultCellAlign: 'left',
      items: [],
      productTypees: []
    };
  },
  created() {
    this.$store.dispatch('producttypemapping/readWebAtelierProductTypes', {}).then(data => {
      this.productTypees = data.data;
    });
    this.refreshList();
  },
  methods: {
    handleProductTypeChange(row, productTypeDescription) {
      if (productTypeDescription !== '') {
        row.webAtelierProductTypeDescription = productTypeDescription;
        return;
      }
      row.webAtelierProductTypeDescription = null;
    },
    refreshList() {
      this.$store.dispatch('producttypemapping/readMappings', {}).then(data => {
        this.items = data.data;
      });
    },
    saveSelection() {
      this.$store.dispatch('producttypemapping/saveMappings', this.items).then(() => {
        this.$store.dispatch('notify/success', { message: this.$i18n.t('common.data_updated') });
        this.refreshList();
      });
    },
    close() {
      closeCurrentTag(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.mapping-table {
  .search-select {
    width: 100%;
    .el-input__inner {
      padding-left: 5px;
    }
    .el-input {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .el-input__suffix {
      top: -2px;
      right: 10px;
    }
  }
}
</style>
